export default __webpack_public_path__ + "static/unsupported-browser-b96312da999d46c874195ea9528eb3a8.png";